import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { type RootState } from "app";
import { initScene } from "features/render";

import { NvdbConfig } from "./types";

const initialState = {
    config: null as NvdbConfig | null,
};

type State = typeof initialState;

export const nvdbSlice = createSlice({
    name: "nvdb",
    initialState,
    reducers: {
        setConfig: (state, action: PayloadAction<State["config"]>) => {
            state.config = action.payload;
        },
    },
    extraReducers(builder) {
        builder.addCase(initScene, (state, action) => {
            state.config = action.payload.sceneData.customProperties.integrations?.nvdb ?? null;
        });
    },
});

export const selectNvdbConfig = (state: RootState) => state.nvdb.config;

const { actions, reducer } = nvdbSlice;
export { actions as nvdbActions, reducer as nvdbReducer };
